import React, { createContext, useContext, useState, useCallback } from 'react'
import Notification from '../../common/SuccessNotification'

const snackbarContext = createContext()

const DEFAULT_SACKBAR_DURATION_SECONDS = 3

const SnackbarType = {
  SUCCESS: 'success',
  ERROR: 'error',
}

export const useSnackbar = () => useContext(snackbarContext)

function SnackbarProvider({ children }) {
  const [snackbarInfo, setSnackbarInfo] = useState(null)

  const setSnackbar = useCallback(
    (message, type, duration = DEFAULT_SACKBAR_DURATION_SECONDS) => {
      setSnackbarInfo({
        key: (snackbarInfo?.key || 0) + 1,
        message,
        type,
        duration,
      })
    },
    [snackbarInfo],
  )

  const setSuccessMessage = useCallback(
    (message, duration) => setSnackbar(message, SnackbarType.SUCCESS, duration),
    [setSnackbar],
  )

  const setErrorMessage = useCallback(
    (message, duration) => setSnackbar(message, SnackbarType.ERROR, duration),
    [setSnackbar],
  )

  return (
    <snackbarContext.Provider value={{ setSuccessMessage, setErrorMessage }}>
      {snackbarInfo && (
        <Notification
          animationKey={snackbarInfo.key}
          duration={snackbarInfo.duration}
          text={snackbarInfo.message}
          onClose={() => setSnackbarInfo(null)}
          isError={snackbarInfo.type === SnackbarType.ERROR}
        />
      )}
      {children}
    </snackbarContext.Provider>
  )
}

export default SnackbarProvider
